import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import ImageUpload from "../../components/imageUpload.js";

const InvoicefooterbgcolorEdit = () => {
  const [colorname, setColorname] = useState("");
  const [r, setR] = useState("");
  const [g, setG] = useState("");
  const [b, setB] = useState("");
  const [redirect, setRedirect] = useState(false);
  const ref = useRef < HTMLInputElement > null;

  let { id } = useParams();
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`invoicefooterbgcolor/${id}`);
      setColorname(data.color_name);
      setR(data.r);
      setG(data.g);
      setB(data.b);
    })();
  }, [id]);
  const submit = async (e) => {
    e.preventDefault();
    const { data } = await axios.put(`invoicefooterbgcolor/${id}`, {
      color_name: colorname,
      r: parseInt(r),
      g: parseInt(g),
      b: parseInt(b),
    });
    console.log(data);
    setRedirect(true);
  };

  if (redirect) {
    return <Navigate to={"/invoicefooterbgcolor"} />;
  }
  return (
    <Wrapper pageTitle={"Edit Invoicefooterbgcolor"}>
      <InnerNav
        createLink={"/invoicefooterbgcolorCreate"}
        listLink={"/invoicefooterbgcolor"}
      />
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">Colorname </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Colorname"
              value={colorname}
              onChange={(e) => setColorname(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">R </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="R"
              value={r}
              onChange={(e) => setR(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">G </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="G"
              value={g}
              onChange={(e) => setG(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">B </span>
            <input
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="B"
              value={b}
              onChange={(e) => setB(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                onClick={submit}
              >
                {" "}
                <FiSave /> <span className="ml-3">Save</span>{" "}
              </button>
            </label>
          </div>
        </div>
      </form>
    </Wrapper>
  );
};
export default InvoicefooterbgcolorEdit;
